import {
  FundingStageName,
  InvestmentCategoryName,
  InvestmentGeographyName,
  InvestmentStageName
} from 'generated/graphql';
import { apolloService } from 'modules';
import { BehaviorSubject } from 'rxjs';

import * as dataService from './dataService';



export const subjAllEnums = new BehaviorSubject<dataService.IAllEnums>({
  investmentCategories:[],
  investmentGeographies: [],
  investmentStages: [],
  investmentAreas: [],
  usStates: [],
  fundingStages: []
});



export async function init(client: apolloService.IApolloClient) {
  const result = await dataService.runQuery(client);

  if (result) {
    subjAllEnums.next(result);
  }
}

export type {
  IGenericEnum,
  IExtendedEnum
} from './dataService';

export type IInvestmentCategory = InvestmentCategoryName;
export type IInvestmentGeography = InvestmentGeographyName;
export type IInvestmentStage = InvestmentStageName;

export type IFundingStage = FundingStageName;
